import { render, staticRenderFns } from "./SlideLogin.vue?vue&type=template&id=2b1933b1&scoped=true&"
import script from "./SlideLogin.vue?vue&type=script&lang=js&"
export * from "./SlideLogin.vue?vue&type=script&lang=js&"
import style0 from "./SlideLogin.vue?vue&type=style&index=0&id=2b1933b1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1933b1",
  null
  
)

export default component.exports